"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OnfidoRoutes = void 0;
const compliance_route_1 = require("./compliance-route");
class OnfidoRoutes extends compliance_route_1.ComplianceRoute {
    constructor() {
        super('onfido');
    }
    /**
     * @description creates applicant on onfido and generates an SDK token.
     * @returns {Object} {
        "applicantId": string,
        "sdkToken": string
    }
    */
    getOnfidoSDKToken() {
        return this.get('/sdk_token');
    }
    /**
     * @description submits documents to Onfido for verification
     * @param docType
     * @param frontId
     * @param backId
     * @param issuingCountry
     * @returns  {Object} {"docId": string }
    */
    uploadDocuments(docType, issuingCountry, frontId, backId, isSecondary) {
        return this.post('/documents', {
            frontId,
            backId,
            docType,
            issuingCountry,
            isSecondary
        });
    }
}
exports.OnfidoRoutes = OnfidoRoutes;
//# sourceMappingURL=onfido.js.map